angular.module('impactx.search').directive('ixSearchInput', function() {
    return {
        restrict: 'E',
        controller: 'SearchInputCtrl',
        controllerAs: 'ctrl',
        scope: {
            global: "=",
            searchFunction: "&"
        },
        templateUrl: 'modules/search/templates/search.input.html'
    }
});